// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "Header" + "_" + "f65f13027dc9c12b" + ".css";
};